import { render, staticRenderFns } from "./Step7Attachments.vue?vue&type=template&id=3060e4ff&scoped=true"
import script from "./Step7Attachments.vue?vue&type=script&lang=js"
export * from "./Step7Attachments.vue?vue&type=script&lang=js"
import style1 from "./Step7Attachments.vue?vue&type=style&index=1&id=3060e4ff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3060e4ff",
  null
  
)

export default component.exports